var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4981 6.66862H4.16605V5.83542C4.16543 3.5346 6.03011 1.66886 8.33093 1.66824C9.84692 1.66781 11.2435 2.49093 11.9774 3.81741C12.2008 4.21981 12.7081 4.36494 13.1105 4.14154C13.5129 3.91813 13.6581 3.41079 13.4347 3.00839C11.8744 0.190335 8.32504 -0.829317 5.50694 0.730956C3.65062 1.75873 2.49892 3.71359 2.49962 5.83546V7.02196C0.983211 7.68378 0.00218717 9.18019 0 10.8347V15.834C0.00277302 18.1336 1.86636 19.9972 4.16605 20H12.4981C14.7978 19.9973 16.6614 18.1336 16.6642 15.834V10.8347C16.6614 8.53494 14.7978 6.67135 12.4981 6.66862ZM9.1653 14.1675C9.1653 14.6277 8.79227 15.0007 8.33211 15.0007C7.87194 15.0007 7.49891 14.6277 7.49891 14.1675V12.5011C7.49891 12.0409 7.87194 11.6679 8.33211 11.6679C8.79227 11.6679 9.1653 12.0409 9.1653 12.5011V14.1675Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/unlockIcon.3718e3aafbbccfde2dde7cc0977330ea.svg";
export { ForwardRef as ReactComponent };